import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';

export const getActionPlanState = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = 'Pendiente';
      break;
    case 1:
      name = 'Ejecutado';
      break;
    case 2:
      name = 'Anulado';
      break;
  }

  return name;
};

export const getReviewState = (number) => {
  let name = '';

  switch (number) {
    default:
    case 0:
      name = 'Revisión por comenzar';
      break;
    case 1:
      name = 'Comunicada revisión a responsable';
      break;
    case 2:
      name = 'Recibida respuesta de responsable';
      break;
    case 3:
      name = 'Validada revisión plan de acción';
      break;
  }

  return name;
};

export const getResponsibleAnswer = (number) => {
  let name = '';

  switch (number) {
    case 0:
      name = 'Realizado plan de acción según definición';
      break;
    case 1:
      name = 'Realizado con incidencias o parcialmente';
      break;
    case 2:
      name = 'No realizado plan de acción';
      break;
  }

  return name;
};
